/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export default function store() {
    return {
        pass: {},
    };
}
